module.exports = __webpack_public_path__ + "media/gateway/mini-cuotas-fc3a4544.png";